(() => {
  const modalClass = "custom-image-modal";
  let panzoomInstance = null;
  let wheelListener = null;
  let lastFocusedElement = null;

  // Helper: generate high-res Shopify URL
  function getHighResShopifyURL(url) {
    return url.replace(
      /_(\d+)x(\d+)\.(jpg|jpeg|png|gif|webp)(\?.*)?$/,
      "_1024x1024.$3$4"
    );
  }

  // Wrap eligible images in <a data-modal-trigger>
  function wrapLightboxImages(container = document) {
    container.querySelectorAll(".rte img, img.expandable-image").forEach(img => {
      if (!img.closest("a[data-modal-trigger]")) {
        const wrapper = document.createElement("a");
        wrapper.href = getHighResShopifyURL(img.src);
        wrapper.setAttribute("data-modal-trigger", "");
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
      }
    });
  }

  // 1. Create the modal if it doesn't already exist
  if (!document.querySelector(`.${modalClass}`)) {
    const modal = document.createElement("div");
    modal.className = `${modalClass} custom-modal media-modal`;
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-labelledby", "custom-image-modal-title");
    modal.innerHTML = `
      <h2 id="custom-image-modal-title" class="visually-hidden">
        Image preview
      </h2>
      <div class="custom-modal__dialog" role="document">
        <button type="button" class="custom-modal__close" aria-label="Close">
          <svg class="icon" viewBox="0 0 20 20">
            <path fill="currentColor" d="M11.42 10l4.29-4.29a1 1 0 10-1.42-1.42L10 8.59 5.71 4.29A1 1 0 004.29 5.71L8.59 10l-4.3 4.29a1 1 0 101.42 1.42L10 11.42l4.29 4.3a1 1 0 001.42-1.42z"/>
          </svg>
        </button>
        <div class="custom-modal__content">
          <div class="panzoom-container">
            <img src="" alt="" class="responsive-image">
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
  }

  // 2. Grab references
  const modal = document.querySelector(`.${modalClass}`);
  const modalClose = modal.querySelector(".custom-modal__close");
  const panzoomContainer = modal.querySelector(".panzoom-container");
  const modalImage = modal.querySelector(".responsive-image");

  // 3. Initial wrap of images
  wrapLightboxImages();

  // 4. Re-wrap when a Shopify section loads dynamically
  document.addEventListener("shopify:section:load", (e) => {
    wrapLightboxImages(e.target);
  });

  // 5. Open modal handler (delegated)
  function openModal(e) {
    const trigger = e.target.closest("[data-modal-trigger]");
    if (!trigger) return;
    e.preventDefault();
    lastFocusedElement = document.activeElement;

    // scrollbar compensation
    const sbWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${sbWidth}px`;

    // cleanup previous Panzoom
    if (panzoomInstance) {
      panzoomContainer.removeEventListener("wheel", wheelListener);
      panzoomInstance.destroy();
      panzoomInstance = null;
      wheelListener = null;
    }

    // set up image
    const fullSrc = trigger.getAttribute("href");
    const img = trigger.querySelector("img");
    modalImage.src = "";
    modalImage.alt = img?.getAttribute("alt") || "Image preview";

    // show modal
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-active");
    document.body.classList.add("modal-open");

    // initialize Panzoom on load
    modalImage.addEventListener("load", onImageLoad);
    modalImage.src = fullSrc;
    modalClose.focus();
  }

  // 6. Panzoom init
  function onImageLoad() {
    if (typeof Panzoom === "function") {
      panzoomInstance = Panzoom(panzoomContainer, {
        maxScale: 5,
        minScale: 1,
        contain: "outside",
      });
      wheelListener = panzoomInstance.zoomWithWheel;
      panzoomContainer.addEventListener("wheel", wheelListener);
    }
    modalImage.removeEventListener("load", onImageLoad);
  }

  // 7. Close modal
  function closeModal() {
    document.body.style.paddingRight = "";
    modal.setAttribute("aria-hidden", "true");
    modal.classList.remove("is-active");
    document.body.classList.remove("modal-open");

    if (panzoomInstance) {
      panzoomContainer.removeEventListener("wheel", wheelListener);
      panzoomInstance.destroy();
      panzoomInstance = null;
      wheelListener = null;
    }

    modalImage.src = "";
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  // 8. Trap focus within modal
  function handleFocusTrap(e) {
    const selectors = `
      a[href], area[href],
      input:not([disabled]), select:not([disabled]),
      textarea:not([disabled]), button:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `;
    const focusable = Array.from(modal.querySelectorAll(selectors))
      .filter(el => el.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // 9. Event bindings
  document.addEventListener("click", openModal);
  modalClose.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => e.target === modal && closeModal());
  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("is-active")) return;
    if (e.key === "Escape") closeModal();
    else if (e.key === "Tab") handleFocusTrap(e);
  });
})();
